import { render, staticRenderFns } from "./list-telegram.vue?vue&type=template&id=6a89bb90&scoped=true"
import script from "./list-telegram.vue?vue&type=script&lang=js"
export * from "./list-telegram.vue?vue&type=script&lang=js"
import style0 from "./list-telegram.vue?vue&type=style&index=0&id=6a89bb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89bb90",
  null
  
)

export default component.exports